import { useMemo, useRef } from 'react'
import { useApiListResultAssessmentUser } from '../../../../api-new/state/assessment'
import { BreadcrumbView } from '../../../../context/breadcrumb.context'
import { CardFullHeightScrollY } from '../../../../shared/card/card-full-height-scroll-y'
import { useParamsInt } from '../../../../shared/hooks/location'
import { Menu, MenuDelete, MenuExport, MenuItem } from '../../../../shared/menu/menu'
import { IconView } from '../../../../shared/icon/icon'
import { useRouteMatch } from '../../../../../node_modules/react-router-dom/cjs/react-router-dom.min'
import { IconList } from '../../../../shared/icon/icon'
import { TableAgClient } from '../../../../shared/table-builder/table-ag-client'
import { ColumnDateTime, ColumnMenu, ColumnText } from '../../../../shared/table-builder/table-columns'

export const AssessmentUserAttempts = () => {
	const { url } = useRouteMatch()
	const { userID, assessmentID } = useParamsInt()

	const apiListResultAssessmentUser = useApiListResultAssessmentUser()

	const handleReady = () => apiListResultAssessmentUser.get(`attempts/${assessmentID}/assessment/${userID}/user`)

	const handleDestroyed = () => apiListResultAssessmentUser.init()

	const title = useMemo(() => {
		let first = apiListResultAssessmentUser.items[0]
		return first ? first.title : ''
	}, [apiListResultAssessmentUser.items])

	const tableRef = useRef()
	const handleExportCsv = () => tableRef.current.exportCsv('assessments')

	const HeaderMenu = () => (
		<Menu>
			<MenuExport onClick={handleExportCsv} show />
		</Menu>
	)

	return (
		<BreadcrumbView Icon={IconList} text={title}>
			<CardFullHeightScrollY title={title} HeaderMenu={HeaderMenu}>
				<TableAgClient ref={tableRef} apiList={apiListResultAssessmentUser} onReady={handleReady} onDestoryed={handleDestroyed}>
					<ColumnText field='course' sortable filter />
					<ColumnText field='title' sortable filter />
					<ColumnText field='type' sortable filter />
					<ColumnText field='passingScore' sortable filter />
					<ColumnText field='score' sortable filter />
					<ColumnText field='passed' sortable filter />
					<ColumnDateTime field='start' sortable filter />
					<ColumnDateTime field='end' sortable filter />
					<ColumnText field='duration' sortable filter />
					<ColumnMenu
						menu={(row) => (
							<Menu small>
								<MenuItem text='details' Icon={IconView} to={`${url}/${row.userAssessmentID}/details`} show pin />
								<MenuDelete to={`${url}/delete/${row.userAssessmentID}`} show pin />
							</Menu>
						)}
					/>
				</TableAgClient>
			</CardFullHeightScrollY>
		</BreadcrumbView>
	)
}
